import React, { useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { corePrograms, WHATSAPP_BASE } from "../mock";

export default function CorePrograms() {
  const trackRef = useRef(null);
  const [active, setActive] = useState(0);

  const scrollByCards = (dir) => {
    if (!trackRef.current) return;
    const card = trackRef.current.querySelector(".prog-card");
    if (!card) return;
    trackRef.current.scrollBy({ left: dir * (card.clientWidth + 24), behavior: "smooth" });
  };

  const onScroll = () => {
    if (!trackRef.current) return;
    const card = trackRef.current.querySelector(".prog-card");
    if (!card) return;
    const idx = Math.round(trackRef.current.scrollLeft / (card.clientWidth + 24));
    setActive(idx);
  };

  const waLink = (title) =>
    `${WHATSAPP_BASE}?text=${encodeURIComponent(`Hi! I'd like to enquire about *${title}* at Nanhe Kadam Therapy Centre, Patna.`)}`;

  return (
    <section className="py-16 lg:py-24 relative">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10 reveal">
          <div>
            <div className="flex items-center gap-2 text-[#7cb342] text-sm font-semibold uppercase tracking-[0.2em]">
              <span className="text-lg twinkle">✦</span> Our Core Programs
            </div>
            <h2 className="mt-3 font-serif text-3xl sm:text-4xl md:text-5xl text-[#122b45] leading-tight max-w-2xl">
              Therapy that helps every <span className="text-[#ee6c4d]">child thrive.</span>
            </h2>
          </div>
          <div className="flex gap-3">
            <button onClick={() => scrollByCards(-1)} aria-label="prev" className="w-12 h-12 rounded-full border border-[#122b45]/15 hover:border-[#ee6c4d] hover:text-[#ee6c4d] text-[#122b45] flex items-center justify-center transition">
              <ChevronLeft className="w-5 h-5" />
            </button>
            <button onClick={() => scrollByCards(1)} aria-label="next" className="w-12 h-12 rounded-full bg-[#122b45] text-white hover:bg-[#0d2138] flex items-center justify-center transition">
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        </div>

        <div
          ref={trackRef}
          onScroll={onScroll}
          className="no-scrollbar flex gap-6 overflow-x-auto snap-x snap-mandatory pb-2 -mx-5 px-5 reveal reveal-delay-200"
        >
          {corePrograms.map((p, idx) => (
            <div
              key={p.title}
              className={`prog-card snap-start relative shrink-0 w-[85%] sm:w-[60%] lg:w-[46%] aspect-[16/11] rounded-[28px] overflow-hidden group reveal-zoom reveal-delay-${(idx + 1) * 100}`}
            >
              <img src={p.img} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              <span className="absolute top-5 left-5 bg-white/95 text-[#122b45] text-xs font-semibold px-3 py-1.5 rounded-full">Featured</span>
              <div className="absolute bottom-6 left-6 right-6 text-white">
                <h3 className="font-serif text-2xl md:text-3xl">{p.title}</h3>
                <p className="text-sm text-white/85 mt-1">{p.sub}</p>
                <a
                  href={waLink(p.title)}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 mt-4 bg-[#25d366] hover:bg-[#20bd5a] text-white text-sm font-semibold px-4 py-2 rounded-full transition"
                >
                  <span className="w-2 h-2 rounded-full bg-white" />
                  Enquire on WhatsApp
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 flex justify-center gap-2">
          {corePrograms.map((_, i) => (
            <span key={i} className={`h-1.5 rounded-full transition-all ${active === i ? "w-8 bg-[#ee6c4d]" : "w-2 bg-[#122b45]/20"}`} />
          ))}
        </div>
      </div>
    </section>
  );
}
